<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form"
                   v-model="form"
                   label-width="100px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="用户名">
                  <el-input v-model="form.username"
                            maxlength="32"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="邮箱">
                  <el-input v-model="form.email"
                            maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input v-model="form.mobile"
                            maxlength="15"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否在线">
                  <el-select v-model="form.loginState"
                             placeholder="是否在线">
                    <el-option label="不限"
                               value=""></el-option>
                    <el-option label="是"
                               value="T"></el-option>
                    <el-option label="否"
                               value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="是否激活">
                  <el-select v-model="form.actFlag"
                             style="width:100%"
                             placeholder="是否激活">
                    <el-option label="不限"
                               value=""></el-option>
                    <el-option label="是"
                               value="T"></el-option>
                    <el-option label="否"
                               value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否黑名单"
                              label-width="100px">
                  <el-select v-model="form.blackList"
                             style="width:100%"
                             placeholder="是否黑名单">
                    <el-option label="不限"
                               value=""></el-option>
                    <el-option label="是"
                               value="T"></el-option>
                    <el-option label="否"
                               value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商家"
                              label-width="100px">
                  <el-select v-model="form.ptnCode"
                             style="width:100%"
                             placeholder="商家">
                    <el-option v-for="item in PartnerLists"
                               :key="item.id"
                               :label="item.ptnName"
                               :value="item.ptnCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button @click="dialogFormVisible = true"
                             size="medium"
                             type="success"
                             icon="el-icon-plus"></el-button>
                  <el-button type="info"
                             @click="onSubmit"
                             size="medium"
                             icon="el-icon-search"></el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row> </el-row>
          </el-form>
        </el-card>
      </div>

      <el-table :data="userList"
                stripe
                :show-overflow-tooltip=true
                style="width: 100%"
                height="500"
                v-loading="loading">
        <el-table-column type="index"
                         label="#"></el-table-column>
        <el-table-column prop="username"
                         label="用户名"
                         width="100"></el-table-column>
        <el-table-column prop="email"
                         label="邮箱"
                         align="center"
                         show-overflow-tooltip
                         min-width="150px"></el-table-column>
        <el-table-column prop="updated_at"
                         label="最后活跃时间"
                         align="center"
                         show-overflow-tooltip
                         min-width="120px"></el-table-column>
        <el-table-column label="在线"
                         prop="loginState"
                         align="center"
                         width="90px;">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.loginState"
                       active-color="#13ce66"
                       active-value="T"
                       inactive-value="F"
                       :disabled="scope.row.loginState =='F'?true:false"
                       @change="chageLogin(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="actFlag"
                         label="激活"
                         align="center"
                         width="65">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.actFlag"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       active-value="T"
                       inactive-value="F"
                       @change="chageAct(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="blackList"
                         label="黑名单"
                         align="center"
                         width="70">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.blackList"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       active-value="T"
                       inactive-value="F"
                       @change="showAddBlack(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="role"
                         label="角色"
                         align="center"
                         show-overflow-tooltip
                         min-width="100px">
          <template slot-scope="scope">
            {{
          scope.row.roles |rolesfilters
          }}
          </template>

        </el-table-column>

        <el-table-column label="操作"
                         min-width="100px"
                         align="center"
                         size="small">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-tooltip effect="dark"
                        content="编辑"
                        placement="top"
                        :enterable="false">
              <el-button type="primary"
                         icon="el-icon-edit"
                         size="mini"
                         @click="showEditDilog(scope.row)"></el-button>
            </el-tooltip>

            <!-- 删除 -->
            <el-tooltip effect="dark"
                        content="删除"
                        placement="top"
                        :enterable="false">
              <el-button type="danger"
                         icon="el-icon-delete"
                         size="mini"
                         @click="delUser(scope.row.id)"></el-button>
            </el-tooltip>

            <!-- 重置密码 -->
            <el-tooltip effect="dark"
                        content="重置密码"
                        placement="top"
                        :enterable="false">
              <el-button type="warning"
                         icon="el-icon-refresh"
                         size="mini"
                         @click="resetUser(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryInfo.pagesize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增用户 -->
    <el-dialog title="新增用户"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="600px"
               @close="addDilogClosed">
      <el-form :model="addform"
               :rules="rules"
               ref="addformRef">
        <el-row class="dialog-row">
          <el-col :span="24">
            <el-form-item label="用户名"
                          prop="username"
                          :label-width="formLabelWidth">
              <el-input v-model="addform.username"
                        autocomplete="off"
                        style="width: 100%"
                        maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮箱"
                          prop="email"
                          :label-width="formLabelWidth">
              <el-input v-model="addform.email"
                        style="width: 100%"
                        maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="密码"
                          prop="password"
                          :label-width="formLabelWidth">
              <el-input type="password"
                        style="width: 100%"
                        v-model="addform.password"
                        maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号"
                          prop="mobile"
                          :label-width="formLabelWidth">
              <el-input v-model="addform.mobile"
                        style="width: 100%"
                        maxlength="15"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="启用"
                          :label-width="formLabelWidth">
              <el-radio-group v-model="addform.actFlag">
                <el-radio label="T">启用</el-radio>
                <el-radio label="F"> 禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商家"
                          prop="ptnCode"
                          :label-width="formLabelWidth">
              <el-select v-model="addform.ptnCode"
                         placeholder="请选择商家"
                         style="width: 100%">
                <el-option v-for="item in PartnerLists"
                           :key="item.id"
                           :label="item.ptnName"
                           :value="item.ptnCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="角色"
                          :label-width="formLabelWidth">
              <el-select v-model="addform.roles"
                         placeholder="请选择角色"
                         style="width: 100%"
                         multiple>
                <el-option v-for="item in roleList"
                           :key="item.id"
                           :label="item.nameCN"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align: center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addUser">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改用户 -->
    <el-dialog title="编辑用户"
               :visible.sync="editdialogFormVisible"
               width="600px"
               @close="editDilogClosed">
      <el-form :model="editform"
               :rules="editrules"
               ref="editformRef">
        <el-form-item label="用户名"
                      prop="username"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.username"
                    autocomplete="off"
                    style="width: 100%"
                    disabled
                    maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="email"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.email"
                    style="width: 100%"
                    maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="密码"
                      prop="password"
                      :label-width="formLabelWidth">
          <el-input type="password"
                    v-model="editform.password"
                    style="width: 100%"
                    maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.mobile"
                    style="width: 100%"
                    maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="启用"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F"> 禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商家"
                      prop="ptnCode"
                      :label-width="formLabelWidth">
          <el-select v-model="editform.ptnCode"
                     placeholder="请选择商家"
                     style="width: 100%">
            <el-option v-for="item in PartnerLists"
                       :key="item.id"
                       :label="item.ptnName"
                       :value="item.ptnCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色"
                      :label-width="formLabelWidth">
          <el-select v-model="editform.roles"
                     placeholder="请选择角色"
                     style="width: 100%"
                     multiple>
            <el-option v-for="item in roleList"
                       :key="item.name"
                       :label="item.nameCN"
                       :value="item.id">{{ item.nameCN}}</el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align: center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveUser">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="加入黑名单"
               :visible.sync="bdialogFormVisible"
               width="500px"
               @close="bDilogClosed">
      <el-form :model="editform"
               ref="editformRef"
               :rules="rules">
        <el-form-item label="原因"
                      prop="reason"
                      label-width="70px">
          <el-input v-model="editform.reason"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="bdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="chageBlacklist">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/
      if (regEmail.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的邮箱'))
    }
    var checkUser = (rule, value, callback) => {
      var regUser = new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
      )
      if (regUser.test(value)) {
        return callback(new Error('用户名不能包含特殊字符'))
      }
      return callback()
    }
    var checkNumbuerUser = (rule, value, callback) => {
      // 正则表达式
      const regNumber = /^([0-9])+/
      if (!regNumber.test(value)) {
        return callback()
      }
      callback(new Error('用户名不能为纯数字'))
    }
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      // 符合规则
      if (regMobile.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }

    return {
      form: {
        username: '',
        email: '',
        mobile: '',
        ptnCode: '',
        actFlag: '',
        blackList: '',
        loginState: '',
        role: '',
      },
      addform: {
        username: '',
        email: '',
        password: '',
        mobile: '',
        ptnCode: '',
        actFlag: '',
        blackList: '',
        loginState: '',
        roles: '',
      },
      editform: {
        username: '',
        email: '',
        password: '',
        mobile: '',
        ptnCode: '',
        actFlag: '',
        blackList: '',
        loginState: '',
        roles: '',
        id: '',
        reason: '',
      },

      rules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          {
            min: 3,
            max: 20,
            message: '长度在 3 到 20 个字符',
            trigger: 'blur',
          },
          { validator: checkUser, trigger: 'blur' },
          { validator: checkNumbuerUser, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '长度在 8 到 20 个字符',
            trigger: 'blur',
          },
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }],
      },
      editrules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' },
        ],

        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
      },

      total: 0,
      userList: [],
      PartnerLists: [],
      queryInfo: {
        query: [],
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      bdialogFormVisible: false,
      dialogFormVisible: false,
      editdialogFormVisible: false,
      roleList: [],
      formLabelWidth: '80px',
      errmsg: '',
      loading: true,
    }
  },
  methods: {
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getUserList()
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val

      this.getUserList()
    },
    handleCurrentChange(val) {
      this.queryInfo.pagenum = val

      this.getUserList()
    },
    // 强制下线
    async chageLogin(userinfo) {
      // 弹框询问是否强制下线
      const confirmResult = await this.$confirm(
        '此操作将强制下线该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认下线
      if (confirmResult == 'confirm') {
        await this.$http
          .put('offline/' + userinfo.id)
          .then((response) => {
            const res = response.data
            console.log(res)
            this.$message.success(res.data)
          })
          .catch((error) => {
            userinfo.loginState = !userinfo.loginState
            return this.$message.error(error.response.data.message)
          })
      } else if (confirmResult == 'cancel') {
        userinfo.loginState = !userinfo.loginState
      }
    },

    // 变更激活状态
    async chageAct(userinfo) {
      await this.$http
        .put('activeuser/' + userinfo.id + '/' + userinfo.actFlag)
        .then((response) => {
          const res = response.data

          this.$message.success(res.data)
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },

    // 加入黑名单
    async chageBlacklist(userinfo) {
      if (this.editform.reason == null) {
        return this.$message.error('请输入原因')
      }
      await this.$http
        .post('addblacklist/', this.editform)
        .then((response) => {
          const res = response.data
          this.bdialogFormVisible = false
          this.$message.success(res.data)
        })
        .catch((error) => {
          userinfo.blackList = !userinfo.blackList
          return this.$message.error(error.response.data.message)
        })
    },
    async getUserList() {
      this.loading = true
      await this.$http
        .post('users', this.queryInfo)
        .then((response) => {
          const res = response.data

          this.userList = res.data.data

          this.total = res.data.total

          this.currentPage = res.current_page
          this.loading = false
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
          this.loading = false
        })
    },
    // 删除用户
    async delUser(userid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认删除
      if (confirmResult == 'confirm') {
        await this.$http
          .delete('deluser/' + userid)
          .then((response) => {
            this.$message.success('删除成功')

            this.pagenum = 1

            this.getUserList()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
    // 重置密码
    async resetUser(userid) {
      // 弹框询问
      const confirmResult = await this.$confirm('确认要重置密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)

      // 确认
      if (confirmResult == 'confirm') {
        await this.$http
          .post('resetpwd/' + userid)
          .then((response) => {
            this.$message.success('操作成功')

            this.currentPage = 1

            this.getUserList()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
    // 获取角色列表
    async getRoleLists() {
      await this.$http
        .post('rolelists', {
          query: '',
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data

          this.roleList = res.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    addDilogClosed() {
      this.$refs.addformRef.resetFields()
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields()
    },
    bDilogClosed() {
      this.$refs.editformRef.resetFields()
    },

    // 点击添加新用户
    async addUser() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return

        await this.$http
          .post('addusers', this.addform)
          .then((response) => {
            this.$message.success('添加用户成功')

            this.dialogFormVisible = false

            this.getUserList()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },

    // 获取商家列表
    async getPartnerLists() {
      const { data: res } = await this.$http.post('ptnlists', {
        query: '',
        pagenum: 1,
        pagesize: 100,
      })

      if (res.meta.status !== 200)
        return this.$message.error('获取商家列表失败')
      this.PartnerLists = res.data.data
    },

    // 显示修改用户对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row)

      this.editform = copy

      this.editform.roles = []

      for (let i in row.roles) {
        this.editform.roles.push(row.roles[i].id)
      }

      this.editdialogFormVisible = true
    },

    // 显示修改用户对话框
    async showAddBlack(row) {
      let copy = Object.assign({}, row)
      this.editform = copy
      this.bdialogFormVisible = true
    },
    // 保存用户更新
    saveUser() {
      this.$refs.editformRef.validate(async (valid) => {
        if (!valid) return

        const { data: res } = await this.$http
          .post('editusers', this.editform)
          .then((response) => {
            this.$message.success('编辑用户成功')

            this.editdialogFormVisible = false

            this.getUserList()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },
  },
  filters: {
    rolesfilters(value) {
      if (value) {
        let roles = value.map(function (i) {
          return i.name
        })
        return roles.toString()
      }
      return value
    },
  },
  created() {
    this.getUserList()
    this.getPartnerLists()
    this.getRoleLists()
  },
}
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/sys/users/index.vue